import React, { useState } from 'react'
import { filter, map } from 'lodash-es'
import Modal from 'reactstrap/lib/Modal'
import ModalHeader from 'reactstrap/lib/ModalHeader'
import ModalBody from 'reactstrap/lib/ModalBody'
import VideoPlayer from './video-player'
import { client } from '../index'
import gql from 'graphql-tag'

const FILE_URL = gql`
  query GetMediaUrl($fileKey: String!) {
    uri: mediaSignedUrl(key: $fileKey)
  }
`

const MediaList = ({useTranslate, media}) => {

  const [videoKey, setVideoKey] = useState("");
  const [videoTitle, setVideoTitle] = useState("");
  const [videoType, setVideoType] = useState("");
  const [showVideo, setShowVideo] = useState(false);

  /*
    const testMedia = [
      {
        "id": "bc528f5f-43bd-40f6-a64f-1f24d5367328",
        "title": "Intro video asdasd",
        "type": "VIDEO",
        "details": {
          "key": "05806696-83db-4a16-812b-751930c3fb04/videos/intro-video.7ae37a2e-cd53-4b34-9bf4-dcfb87386f4c.mov",
          "__typename": "MediaDetails"
        },
        "__typename": "SurveyMedia"
      },
      {
        "id": "bc528f5f-43bd-40f6-a64f-1f24d5367328",
        "title": "Intro video to innovation capability",
        "type": "VIDEO",
        "details": {
          "key": "05806696-83db-4a16-812b-751930c3fb04/videos/intro-video.7ae37a2e-cd53-4b34-9bf4-dcfb87386f4c.mov",
          "__typename": "MediaDetails"
        },
        "__typename": "SurveyMedia"
      },
      {
        "id": "da9e8d3b-854b-43a3-8deb-10d5c97df598",
        "title": "About Engager",
        "type": "PDF",
        "details": {
          "key": "05806696-83db-4a16-812b-751930c3fb04/files/mika-engager.3761ab2d-2378-43b9-8e95-1d40e3b80ecf.pdf",
          "__typename": "MediaDetails"
        },
        "__typename": "SurveyMedia"
      },
      {
        "id": "80ce5f6a-4d09-4eac-a008-b7ef8e9d4865",
        "title": "Building blocks of innovation capabiity",
        "type": "PDF",
        "details": {
          "key": "05806696-83db-4a16-812b-751930c3fb04/files/building-blocks-for-innovation-capability.f4191ecf-94aa-46b7-99d3-1fdbd1ee6df7.pdf",
          "__typename": "MediaDetails"
        },
        "__typename": "SurveyMedia"
      }
    ]

    let mediaVideos = testMedia && testMedia.length > 0 ? filter(testMedia, (item) => item.type === "VIDEO") : [];
    let mediaFiles = testMedia && testMedia.length > 0 ? filter(testMedia, (item) => item.type !== "VIDEO") : [];
*/

  let mediaVideos = media && media.length > 0 ? filter(media, (item) => item.type === "VIDEO") : [];
  let mediaFiles = media && media.length > 0 ? filter(media, (item) => item.type !== "VIDEO") : [];

  let embeddableVideos = [];
  if (useTranslate("landing.video_embed_url_1").includes("https://www.youtube.com/embed/")) {
    embeddableVideos.push(
      {
        "url": useTranslate("landing.video_embed_url_1"),
        "type": "YOUTUBE",
        "title": useTranslate("landing.video_embed_title_1"),
      }
    );
  }
  if (useTranslate("landing.video_embed_url_2").includes("https://www.youtube.com/embed/")) {
    embeddableVideos.push(
      {
        "url": useTranslate("landing.video_embed_url_2"),
        "type": "YOUTUBE",
        "title": useTranslate("landing.video_embed_title_2"),
      }
    );
  }

  const showVideoModal = (key, title, type) => {
    setShowVideo(true);
    setVideoKey(key);
    setVideoTitle(title);
    setVideoType(type);
  };

  const hideVideoModal = () => {
    setShowVideo(false);
    setVideoKey("");
    setVideoTitle("");
    setVideoType("");
  };

  const renderVideoModal = () => {
    return (
      <Modal isOpen={showVideo} toggle={hideVideoModal} className="modal-lg">
        <ModalHeader toggle={hideVideoModal}>{videoTitle}</ModalHeader>
        <ModalBody>
          <VideoPlayer
            videoKey={videoKey}
            handleMediaClick={handleMediaClick}
            useTranslate={useTranslate}
            type={videoType}
          />
        </ModalBody>
      </Modal>
    );
  }

  const handleMediaClick = async (key) => {
    client
      .query({
        query: FILE_URL,
        variables: {
          fileKey: key,
        },
      })
      .then(({ data: { uri } }) => window.open(uri, "_blank"))
      // TODO: figure out what to do with errors here
      .catch((e) => console.log(e));
  }

  const handleVideoClick = (key, title, type) => {
    showVideoModal(key, title, type);
  }

  const renderPreviewIcon = (type) => {
    switch (type) {
      case "PDF":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            width="46"
            height="46"
            enableBackground="new 0 0 512 512"
            version="1.1"
            viewBox="0 0 512 512"
            xmlSpace="preserve"
          >
            <path
              fill="#E2E5E7"
              d="M128 0c-17.6 0-32 14.4-32 32v448c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32V128L352 0H128z"
            ></path>
            <path
              fill="#B0B7BD"
              d="M384 128h96L352 0v96c0 17.6 14.4 32 32 32z"
            ></path>
            <path fill="#CAD1D8" d="M480 224L384 128 480 128z"></path>
            <path
              fill="#F15642"
              d="M416 416c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v160z"
            ></path>
            <g fill="#FFF">
              <path d="M101.744 303.152c0-4.224 3.328-8.832 8.688-8.832h29.552c16.64 0 31.616 11.136 31.616 32.48 0 20.224-14.976 31.488-31.616 31.488h-21.36v16.896c0 5.632-3.584 8.816-8.192 8.816-4.224 0-8.688-3.184-8.688-8.816v-72.032zm16.88 7.28v31.872h21.36c8.576 0 15.36-7.568 15.36-15.504 0-8.944-6.784-16.368-15.36-16.368h-21.36zM196.656 384c-4.224 0-8.832-2.304-8.832-7.92v-72.672c0-4.592 4.608-7.936 8.832-7.936h29.296c58.464 0 57.184 88.528 1.152 88.528h-30.448zm8.064-72.912V368.4h21.232c34.544 0 36.08-57.312 0-57.312H204.72zM303.872 312.112v20.336h32.624c4.608 0 9.216 4.608 9.216 9.072 0 4.224-4.608 7.68-9.216 7.68h-32.624v26.864c0 4.48-3.184 7.92-7.664 7.92-5.632 0-9.072-3.44-9.072-7.92v-72.672c0-4.592 3.456-7.936 9.072-7.936h44.912c5.632 0 8.96 3.344 8.96 7.936 0 4.096-3.328 8.704-8.96 8.704h-37.248v.016z"></path>
            </g>
            <path
              fill="#CAD1D8"
              d="M400 432H96v16h304c8.8 0 16-7.2 16-16v-16c0 8.8-7.2 16-16 16z"
            ></path>
          </svg>
        );
      case "IMAGE":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="46"
            height="46"
            viewBox="0 0 512 512"
          >
            <path
              fill="#ffcb66"
              d="M76 331H15c-8.291 0-15-6.709-15-15V46c0-8.291 6.709-15 15-15h361c8.291 0 15 6.709 15 15v60c0 8.291-6.709 15-15 15H151v75c0 8.291-6.709 15-15 15H91v105c0 8.291-6.709 15-15 15z"
            ></path>
            <path
              fill="#ffa54d"
              d="M376 31H256v90h120c8.291 0 15-6.709 15-15V46c0-8.291-6.709-15-15-15z"
            ></path>
            <path
              fill="#e6f2f2"
              d="M497 391h-61c-8.291 0-15-6.709-15-15V211H136c-8.291 0-15-6.709-15-15v-90c0-8.291 6.709-15 15-15h361c8.291 0 15 6.709 15 15v270c0 8.291-6.709 15-15 15z"
            ></path>
            <path
              fill="#cfe6e6"
              d="M497 91H256v120h165v165c0 8.291 6.709 15 15 15h61c8.291 0 15-6.709 15-15V106c0-8.291-6.709-15-15-15z"
            ></path>
            <path
              fill="#66b3ff"
              d="M436 181H76c-8.401 0-15 6.599-15 15v270c0 4.2 1.8 7.8 4.2 10.8L166 436h120l160.8 40.8c2.4-3 4.2-6.6 4.2-10.8V196c0-8.401-6.599-15-15-15z"
            ></path>
            <path
              fill="#4d88ff"
              d="M436 181H256v255h30l160.8 40.8c2.4-3 4.2-6.6 4.2-10.8V196c0-8.401-6.599-15-15-15z"
            ></path>
            <g>
              <path
                fill="#ade65c"
                d="M446.8 476.8c-3 2.4-6.6 4.2-10.8 4.2H76c-4.2 0-7.8-1.8-10.8-4.2l90.193-90.193c5.858-5.858 15.355-5.858 21.213 0l8.787 8.787c5.858 5.858 15.355 5.858 21.213 0l68.787-68.787c5.858-5.858 15.355-5.858 21.213 0z"
              ></path>
              <path
                fill="#ffcb66"
                d="M166 331c-24.814 0-45-20.186-45-45s20.186-45 45-45 45 20.186 45 45-20.186 45-45 45z"
              ></path>
            </g>
            <path
              fill="#7acc52"
              d="M275.393 326.605L256 345.998V481h180c4.2 0 7.8-1.8 10.8-4.2L296.607 326.605c-5.859-5.857-15.355-5.857-21.214 0z"
            ></path>
          </svg>
        );
      case "VIDEO":
      case "YOUTUBE":
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="46"
            height="46"
            viewBox="0 0 512 512"
          >
            <g fill="#dfe7f4">
              <path d="M15 406v60h482v-60H256zM256 46H15v60h482V46z"></path>
            </g>
            <path
              fill="#c7cfe1"
              d="M256 46h241v60H256zM256 406h241v60H256z"
            ></path>
            <path fill="#ff641a" d="M256 106H30v300h452V106z"></path>
            <path fill="#f03800" d="M256 106h226v300H256z"></path>
            <g fill="#404a80">
              <path d="M0 391v90h512v-90H256zm81 60H30v-30h51zm80 0h-50v-30h50zm80 0h-50v-30h50zm190-30h51v30h-51zm-80 0h50v30h-50zm-80 0h50v30h-50zM256 31H0v90h512V31zM81 91H30V61h51zm80 0h-50V61h50zm80 0h-50V61h50zm80 0h-50V61h50zm80.001 0H351V61h50.001zM482 91h-51.099V61H482z"></path>
            </g>
            <g fill="#283366">
              <path d="M321 91h-50V61h50zm80.001 0H351V61h50.001zM256 31v90h256V31zm226 60h-51.099V61H482zM512 391H256v90h256zm-191 60h-50v-30h50zm80 0h-50v-30h50zm81 0h-51v-30h51z"></path>
            </g>
            <path
              fill="#f0f7ff"
              d="M256 197.976l-45-29.998v176.044l45-29.998L343.041 256z"
            ></path>
            <path fill="#dfe7f4" d="M256 197.976v116.048L343.041 256z"></path>
          </svg>
        );
      default:
        return;
    }
  };

  const renderMediaFile = (media, index) => {
    const {
      title,
      details: { key },
      type,
    } = media;

    return (
      <div
        key={index}
        className="about__files__file hover"
        onClick={type === "VIDEO" ? () => handleVideoClick(key, title, type) : () => handleMediaClick(key)}
      >
        <div className="about__files__file__preview">
          {renderPreviewIcon(type)}
        </div>
        <div className="about__files__file__text d-flex h-100 flex-column justify-content-center">
          <div className="about__files__file__text__title">{title}</div>
        </div>
      </div>
    );
  };

  const renderEmbedVideo = (item, index) => {

    const {
      title,
      url,
      type,
    } = item;

    return (
      <div
        key={index}
        className="about__files__file hover"
        onClick={() => handleVideoClick(url, title, type)}
      >
        <div className="about__files__file__preview">
          {renderPreviewIcon(type)}
        </div>
        <div className="about__files__file__text d-flex h-100 flex-column justify-content-center">
          <div className="about__files__file__text__title">{title}</div>
        </div>
      </div>
    )
  };

  return (
    <div>
      {((media && media.length > 0) || embeddableVideos.length > 0) &&
        <div className="about__media">
          { embeddableVideos.length > 0 &&
            <div className="about__files">
              {map(embeddableVideos, renderEmbedVideo)}
            </div>
          }
          { mediaVideos && mediaVideos.length > 0 &&
            <div className="about__files">
              {map(mediaVideos, renderMediaFile)}
            </div>
          }
          { mediaFiles && mediaFiles.length > 0 &&
            <div className="about__files">
              {map(mediaFiles, renderMediaFile)}
            </div>
          }
          <div>{renderVideoModal()}</div>
        </div>
      }
    </div>
  )
}

export default MediaList;


// WEBPACK FOOTER //
// ./src/components/media-list.js